import api, {create, deleteOne, getAll, getOne, listAll, getList, RequestResponse, update} from '../api';
import {QueryParams, Clientes} from '../../types';
const endpoint = 'leituras';
export default  {
    /*all: async (params?: QueryParams) => getAll<Clientes>({ endpoint, params }),
    listAll: async () => listAll<Clientes>({ endpoint }),
    getList: async () => getList<Clientes>({ endpoint }),
    one: async (id: string) => getOne<Clientes>({ endpoint, id }),
    destroy: async (id: string) => deleteOne({ endpoint, id }),
    create: async (formData: Partial<Clientes>) => create<Clientes>({ endpoint, formData }),
    update: async (id: string, formData: Partial<Clientes>) => update<Clientes>({ endpoint, formData, id }),*/
    async getLeituras(search: any){
        try {
            const url = `leituras/getByCliente/${search.dataInicio}/${search.dataFim}`;
            const { data } = await api.get(url)
            return { data, isError: false };
        } catch (err: any) {
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    },

    async getLeiturasApontamento(search: any){
        try {
            const url = `leituras-avulsas/getByCliente/${search.dataInicio}/${search.dataFim}`;
            const { data } = await api.get(url)
            return { data, isError: false };
        } catch (err: any) {
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    },
}